const theme = {
  id: "avengers",
  primary: "#F01313", //red
  secondary: "#EFECEA", //light gray
  background: "#334854", // blue
  third: "#F9C535", // yellow
};

export default theme;
